<div class="padding">

  <div class="row" *ngIf="withStatistics">
    <!-- Last finished-->
    <div class="col-md-4">
      <gp-ui-expandable-box #box1>
        <div class="gp-box-header">
          <div class="pull-left m-r">
            <span class="w-40 rounded primary">
              <i class="fa-solid fa-list"></i>
            </span>
          </div>
          <div class="clear">
            <h3 *ngIf="statistics?.latestFinishedRequest">
              {{ 'PAYROLL_ONGOING.calculation_n_finished' | translate:{
              statisticsLatestFinishedRequestId: statistics.latestFinishedRequest.attributes.requestPerYear
            } }}
              <span>{{ statistics.latestFinishedRequest.attributes.launchDate.toString() | gpDate:{timeAgo: true} }}</span>
            </h3>

            <h3 *ngIf="statistics?.latestFinishedRequest == null">
              {{ 'PAYROLL_ONGOING.no_pay_request_finished_recently' | translate }}
            </h3>
            <small>{{ 'PAYROLL_ONGOING.ongoing_calculations' | translate:{
              statisticsOngoingCalculations: statistics?.ongoingCalculations || 0
            } }}
            </small>
          </div>
        </div>
        <div class="gp-box-body">
          <table class="table box-body-table">
            <thead>
            <tr>
              <th>{{ 'COMMON.progress' | translate }}</th>
              <th>{{ 'PAYROLL_ONGOING.calculations' | translate }}</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let request of statistics?.latestRequests">
              <td class="half-width">
                <!-- progress -->
                <div class="progress">
                  <div class="info" [style.width]="request.attributes.progress + '%'">
                    <p class="small text-center">{{request.attributes.progress}}%</p>
                  </div>
                </div>
              </td>
              <td class="half-width">
                <!-- payrolls -->
                <span>
                  {{ 'PAYROLL_ONGOING.calculation_n_lauched' | translate:{
                  requestId: request.attributes?.requestPerYear || request.id,
                  requestAttributesLaunchDate: request.attributes.launchDate.toString() | gpDate:{timeAgo: true}
                } }}</span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </gp-ui-expandable-box>
    </div>

    <!-- Calculate / review box-->
    <div class="col-md-4">
      <gp-ui-expandable-box #box3>
        <div class="gp-box-header">
          <div class="pull-left m-r">
            <gp-graph-pie-chart [width]="40" [height]="40" [data]="payrollHeaderChartData"></gp-graph-pie-chart>
          </div>
          <div class="clear">
            <h3>{{ 'PAYROLL_ONGOING._to_calculate_to_review' | translate:{
              payrollHeaderChartData0Value: payrollHeaderChartData[0]?.value || 0,
              payrollHeaderChartData1Value: payrollHeaderChartData[1]?.value || 0
            } }}</h3>
            <small>{{ 'PAYROLL_ONGOING._contracts_managed' | translate:{
              statisticsContractsManaged: statistics?.contractsManaged || 0
            } }}
            </small>
          </div>
        </div>
        <div class="gp-box-body">
          <gp-echart
            [height]="'350px'"
            [width]="'100%'"
            [options]="payrollStatusChart"
            (datumClick)="updateFilter('payState.status', $event.key); filtersVisible = true; box3.close()"
          ></gp-echart>
        </div>
      </gp-ui-expandable-box>
    </div>

    <!-- Finished / ongoing status -->
    <div class="col-md-4">
      <gp-ui-expandable-box test-id="ongoingStatus" #box2>
        <div class="gp-box-header">
          <div class="pull-left m-r">
            <span class="w-40 rounded warn">
              <i class="fa-solid fa-list-check"></i>
            </span>
          </div>
          <div class="clear">
            <h3>{{ 'PAYROLL_ONGOING._finished' | translate:{
              statisticsFinishedPayrolls: statistics?.finishedPayrolls || 0
            } }}
            </h3>

            <small>{{ 'PAYROLL_ONGOING._ongoing_payrolls' | translate:{
              statisticsOngoingPayrolls: statistics?.ongoingPayrolls || 0
            } }}
            </small>
          </div>
        </div>
        <div class="gp-box-body" style="max-height: 350px; overflow: auto;">
          <h6>{{ 'PAYROLL_ONGOING.done_freeze_progress' | translate }}</h6>
          <table class="table box-body-table">
            <thead>
            <tr>
              <th>{{ 'COMMON.progress' | translate }}</th>
              <th>{{ 'COMMON.payrolls' | translate }}</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let serie of statistics?.paySeries">
              <td class="half-width">
                <!-- progress -->
                <div class="progress">
                  <div class="info" [style.width]="serie.progress + '%'">
                    <p [attr.test-id]="serie.name"
                       class="small text-center">
                      {{serie.progress}}%
                    </p>
                  </div>
                </div>
              </td>
              <td class="half-width">
                <!-- payrolls -->
                {{ serie.name }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </gp-ui-expandable-box>
    </div>
  </div>

  <div class="box shadow">
    <div class="box-header white" [gp-stick-between]="{top:64}">
      <div class="row">
        <div class="pull-left box-title">
          <h3>{{ 'PAYROLL_ONGOING.ongoing_payrolls' | translate }}</h3>
        </div>
        <div class="pull-right p-r">
          <span class="text-muted">{{ 'PAYROLL_ONGOING.selection' | translate }}: </span>
          <span
            class="text-info">{{ 'PAYROLL_ONGOING._launch' | translate:{size: getSelectedActionsCount(actions.LAUNCH)} || 0 }}</span>
          <span class="text-muted"> - </span>
          <span
            class="text-warning">{{ 'PAYROLL_ONGOING._done' | translate:{size: getSelectedActionsCount(actions.DONE)} || 0 }}</span>
          <span class="text-muted"> - </span>
          <span
            class="text-success">{{ 'PAYROLL_ONGOING._freeze' | translate:{size: getSelectedActionsCount(actions.FIX)} || 0 }}</span>
        </div>
        <div>
          <em test-id="fetchPayrolls"
              class="m-l fa fa-light fa-sync pointer refresh-btn pull-left m-r"
              (click)="resetTable()"></em>

          <gp-dropdown-select [inline]="true"
                              buttonClasses="btn btn-sm btn-warning btn-outline button--noBorder"
                              [direction]="'down'"
                              [withoutButtons]="false"
                              [disabled]="!hasAnyExecutableActionSelected()"
                              [ngModel]="selectedAction"
                              (ngModelChange)="executeAction($event)"
                              name="splitButton" ngDefaultControl
                              [forceDisplayValue]="getButtonLabelBasedOnAction()"
                              menuClasses="actions-menu"
                              *ngIf="hasMoreThanOneActionTypeSelected()">

            <gp-dropdown-option *ngFor="let option of gpSelectOptions"
                                [hidden]="!getSelectedActionsCount(option.action)|| executingActions"
                                [ngValue]="option.action">
              <em *ngIf="executingActions && option.executeAll" class="fa fa-light fa-spinner fa-spin"></em>
              <span
                [ngClass]="option.cssClass">{{ option.label | translate:{massActionCount: getSelectedActionsCount(option.action) || 0} }}</span>
            </gp-dropdown-option>


          </gp-dropdown-select>


          <button *ngIf="!hasMoreThanOneActionTypeSelected()"
                  class="btn white text-left btn-sm btn-warning btn-outline button--noBorder"
                  (click)="executeAction()"
                  test-id="dropdownButton"
                  [disabled]="!hasAnyExecutableActionSelected()">
            <span class="direction-ltr d-inline-block" [innerHTML]="getButtonLabelBasedOnAction()"></span>
          </button>
        </div>


      </div>
    </div>

    <div class="box-body">
      <div class="" role="region" aria-labelledby="caption" tabindex="0">
        <table
          test-id="ongoing-payrolls"
          class="table table-striped gp-table ongoing-payroll-table"
          id="ongoing-payrolls"
          aria-describedby="OnGoingPayList">
          <thead class="headers white ongoing-payroll-table-header-sticky-top">
          <tr role="row">
            <th scope="col" class="col-checkbox text-center">
              <div class="checkbox">
                <input type="checkbox"
                       [attr.test-id]="'display-all-pays-checkbox'"
                       [disabled]="executingActions"
                       [indeterminate]="isIndeterminate()"
                       [checked]="isAllChecked()"
                       [tooltip]="getSelectAllCheckBoxToolTip() | translate"
                       (click)="selectAllPays($event)">
              </div>
            </th>
            <th class="text-sm w-170" scope="col">
              {{ 'EMPLOYEE_MANAGE.pay_type' | translate }}
            </th>
            <th class="sorting text-sm pointer w-220" scope="col"
                (click)="toggleColumnSort('payRollSerieName,payRollPeriodsName')">
              {{ 'COMMON.payroll' | translate }}
              <i class="fa fa-light"
                 [ngClass]="{
                   'text-muted': getColumnSortDirection('payRollSerieName,payRollPeriodsName') == null,
                   'fa-sort-up': getColumnSortDirection('payRollSerieName,payRollPeriodsName') != directions.DESCENDING,
                   'fa-sort-down': getColumnSortDirection('payRollSerieName,payRollPeriodsName') == directions.DESCENDING
                 }" aria-hidden="true"></i>
            </th>
            <th class="text-sm w-70" scope="col">
              {{ 'FORMS.id' | translate }}
            </th>
            <th class="sorting text-sm pointer w-170" scope="col"
                (click)="toggleColumnSort('lastName,firstName,cliRegId')">
              {{ 'FORMS.name' | translate }}
              <i class="fa fa-light"
                 [ngClass]="{
                   'text-muted': getColumnSortDirection('lastName,firstName,cliRegId') == null,
                   'fa-sort-up': getColumnSortDirection('lastName,firstName,cliRegId') != directions.DESCENDING,
                   'fa-sort-down': getColumnSortDirection('lastName,firstName,cliRegId') == directions.DESCENDING
                 }" aria-hidden="true"></i>
            </th>
            <th class="text-sm w-xs" scope="col">
              {{ 'PAYROLL_ONGOING.status' | translate }}
            </th>
            <th gp-roles scope="col"
                [userRoles]="['PAYROLL_WRITE']"
                class="text-sm w-sm ">
              {{ 'PAYROLL_ONGOING.actions' | translate }}
            </th>
            <th class="text-sm w-xxs" scope="col">
              {{ 'PAYROLL_ONGOING.retro_short_title' | translate }}
            </th>
            <th class="text-sm w-sm" scope="col">
              <div class="d-inline-block m-x-xs pointer pay-indicator" (click)="toggleColumnSort('nbCriticalAlert')">
                <i class="fa fa-light fa-bell text-danger"
                   [tooltip]="'TOOLTIPS.errors_alerts' | translate" aria-hidden="true"></i>
                <i class="fa fa-light"
                   [ngClass]="{
                   'text-muted': getColumnSortDirection('nbCriticalAlert') == null,
                   'fa-sort-up': getColumnSortDirection('nbCriticalAlert') != directions.DESCENDING,
                   'fa-sort-down': getColumnSortDirection('nbCriticalAlert') == directions.DESCENDING
                 }" aria-hidden="true"></i>
              </div>
              <div class="d-inline-block m-x-xs pointer pay-indicator" (click)="toggleColumnSort('nbInfoAlert')">
                <i class="fa fa-light fa-bell text-warn pointer"
                   [tooltip]="'TOOLTIPS.warn_infos' | translate" aria-hidden="true"></i>
                <i class="fa fa-light"
                   [ngClass]="{
                   'text-muted': getColumnSortDirection('nbInfoAlert') == null,
                   'fa-sort-up': getColumnSortDirection('nbInfoAlert') != directions.DESCENDING,
                   'fa-sort-down': getColumnSortDirection('nbInfoAlert') == directions.DESCENDING
                 }" aria-hidden="true"></i>
              </div>
              <i class="fa fa-light fa-cog m-x-xs caption-icons"
                 [tooltip]="'TOOLTIPS.calculations' | translate" aria-hidden="true"></i>
            </th>
            <th gp-roles
                [userRoles]="['PAYROLL_WRITE']"
                scope="col"
                class="text-sm w-75">
              <span class=" hidden-lg-down">{{ 'PAYROLL_ONGOING.more_actions' | translate }}</span>
              <span class="hidden-xl-up"><i class="fa fa-light fa-recycle" aria-hidden="true"></i></span>
            </th>
            <th class="sorting text-sm pointer w-170" scope="col"
                (click)="toggleColumnSort('lastExecutionId')">
              <span class="hidden-lg-down">{{ 'PAYROLL_ONGOING.last_calculation' | translate }}</span>
              <span class="hidden-xl-up"><i class="fa fa-light fa-info" aria-hidden="true"></i></span>
              <i class="direction-gap fa fa-light"
                 [ngClass]="{
                   'text-muted': getColumnSortDirection('lastExecutionId') == null,
                   'fa-sort-up': getColumnSortDirection('lastExecutionId') == directions.ASCENDING,
                   'fa-sort-down': getColumnSortDirection('lastExecutionId') == directions.DESCENDING
                 }" aria-hidden="true"></i>
            </th>
            <th class="text-sm w-75" scope="col">
              <!-- Actions -->
              <div class="pull-right">
                <button class="btn btn-sm btn-icon white"
                        [class.active]="!filtersVisible"
                        (click)="filtersVisible = !filtersVisible"
                        [tooltip]="'TOOLTIPS.filters' | translate"
                        [disabled]="!pays === null || !pays?.length">
                  <i class="fa fa-light fa-filter pointer" aria-hidden="true"></i>
                </button>
              </div>
            </th>
          </tr>

          <tr [formGroup]="filtersGroup" class="row" [attr.data-hidden]="filtersVisible">
            <td class="col-checkbox"></td>
            <td>
              <select class="form-control"
                      [attr.readOnly]="isPayTypeFilterDisabled ? 'true' : null"
                      formControlName="payTypeTransId">
                <option></option>
                <option *ngFor="let payType of payTypes" [value]="payType.transId"
                        [selected]="isFilterSet('payTypeTransId', payType.transId)">
                  {{payType.transId | translate}}
                </option>
              </select>
            </td>
            <td>
              <!-- Series -->
              <select
                test-id="contractPeriod"
                class="form-control"
                formControlName="contractPeriodId">
                <option></option>
                <option [attr.test-id]="payPeriod.attributes.serie.transid"
                        *ngFor="let payPeriod of payPeriods$ | async | sortByTranslations:
                         triggerSortByTranslationPipe :['attributes.serie.transid','attributes.transid'] | async"
                        [value]="payPeriod.id"
                        [selected]="isFilterSet('contractPeriod.id', '' + payPeriod.id)">
                  {{ payPeriod.attributes.serie.transid | translate }} -
                  {{ payPeriod.attributes.transid | translate }}
                </option>
              </select>
            </td>
            <td>
              <!-- ID -->
              <input type="text"
                     class="form-control"
                     formControlName="externalNumber"/>
            </td>
            <td>
              <!-- firstName + lastName -->
              <input type="text"
                     class="form-control"
                     formControlName="name"/>
            </td>
            <td>
              <!-- Status-->
              <select class="form-control"
                      formControlName="status">
                <option></option>
                <option *ngFor="let status of statusTypes | sortByTranslations:
                        triggerSortByTranslationPipe :['name'] | async" [value]="status.key"
                        [selected]="isFilterSet('payState.status', status.key)">
                  {{ status.name | translate}}
                </option>
              </select>
            </td>
            <td>
              <select class="form-control"
                      formControlName="action">
                <option></option>
                <option *ngFor="let actionType of actionTypes" [value]="actionType.key"
                        [selected]="isFilterSet('actions', actionType.name)">
                  {{ actionType.name | translate}}
                </option>
              </select>

            </td>
            <td>
              <!-- Retro -->
              <select class="form-control"
                      test-id="filter-retro"
                      formControlName="retroActivityCalculationCount">
                <option></option>
                <option [value]="'yes'"
                        [selected]="isFilterSet('payState.retroActivityCalculationCount', '0', '=gt=')">
                  {{ 'COMMON.yes' | translate}}
                </option>
                <option [value]="'no'" [selected]="isFilterSet('payState.retroActivityCalculationCount', '0', '==')">
                  {{ 'COMMON.no' | translate}}
                </option>
              </select>
            </td>
            <td colspan="4" class="text-right"></td>
          </tr>
          </thead>
          <tbody>
          <tr *ngIf="pays === null">
            <td colspan="11" class="text-center p-t-lg p-b-lg">
              <i class="fa fa-light fa-spinner fa-spin" aria-hidden="true"></i>
            </td>
          </tr>
          <tr *ngIf="pays !== null && !pays.length">
            <td colspan="11" class="text-center p-t-lg p-b-lg">
              {{ 'PAYROLL_ONGOING.no_payroll_found' | translate }}
            </td>
          </tr>

          <tr *ngFor="let pay of pays;">
            <td class="text-center col-checkbox">
              <div class="checkbox">
                <input type="checkbox"
                       [attr.test-id]="'display-pay-checkbox-' +pay.id"
                       [disabled]="executingActions"
                       [checked]="pay.selected"
                       (click)="selectPay($event ,pay)">
              </div>
            </td>

            <td>
              {{pay.payTypeTransId | translate}}
            </td>
            <td>
              <span class="text-nowrap">
                <img class="flag-icon" [attr.src]="getFlagLink(pay)"/>
                {{ pay.payRollSerieName | translate}} - {{ pay.payRollPeriodsName | translate }}
              </span>
            </td>
            <td>{{ pay | gpPayId }}</td>
            <td>
              <span [tooltip]="contractDetailsTooltip">
                <a (click)="openEmployeeFile(pay)">
                  {{ pay.lastName }} {{ pay.firstName }}
                </a>
              </span>
              <ng-template #contractDetailsTooltip>
                <span class="block">{{pay.cliRegNickname | translate}}</span>
                <span class="block" *ngIf="hasContractEndDate(pay); else noContractEndDate">
                  ({{pay.contractBeginDate | gpDate: {}: (triggerDateFormat$ | async)}}
                  &#8594; {{(pay.contractEndDate | gpDate: {}: (triggerDateFormat$ | async))}})
                </span>
                <ng-template #noContractEndDate>
                  <span class="block">({{pay.contractBeginDate | gpDate: {}: (triggerDateFormat$ | async)}} &#8594; &hellip;)</span>
                </ng-template>
              </ng-template>
            </td>
            <td>
              <span *ngIf="isAgain(pay) else unfreezeUnavailable"
                    (click)="viewRetroChanges($event, pay)"
                    class="label-again nowrap">
                {{ getPayrollStatus(pay.status) }}
                <em class="fa fa-light fa-info-circle text-info"></em>
              </span>

              <ng-template #unfreezeUnavailable>
                <span
                  *ngIf="isUnfreezeUnavailableInCurrentPeriod(pay) || isUnfreezeUnavailableInFuturePeriod(pay) else defaultStatus"
                  class="label-again nowrap">
                  <span [popover]="unfreezeUnavailablePopOver"
                        [attr.test-id]="'unfreezeUnavailable-popover-' + pay.id"
                        popoverTitle="{{'PAYROLL_ONGOING.unavailable_unfreeze_title' | translate}}"
                        triggers="mouseenter:mouseleave"
                        container="body"
                        placement="top">
                    {{ getPayrollStatus(pay.status) }}
                    <em class="fa fa-light fa-info-circle text-info"></em>
                  </span>
                </span>
              </ng-template>

              <ng-template #defaultStatus>
                <span>{{ getPayrollStatus(pay.status) }}</span>
              </ng-template>

              <ng-template #unfreezeUnavailablePopOver>
                <span *ngIf="isUnfreezeUnavailableInCurrentPeriod(pay)"
                      [attr.test-id]="'display-unfreezeUnavailable-popover-' + pay.id">
                  <p>
                    {{'PAYROLL_ONGOING.payslip_generated' | translate}}:
                    <em
                      [ngClass]="pay.payslipStatus === PayslipPaymentStatus.TODO || pay.payslipStatus === PayslipPaymentStatus.ERROR ? 'fa-times': 'fa-check'"
                      class="fa fa-light"></em>
                  </p>
                  <p>
                    {{'PAYROLL_ONGOING.payment_generated' | translate}}:
                    <em
                      [ngClass]="pay.paymentStatus === PayslipPaymentStatus.TODO || pay.paymentStatus === PayslipPaymentStatus.ERROR ? 'fa-times': 'fa-check'"
                      class="fa fa-light"></em>
                  </p>
                </span>
                <span *ngIf="isUnfreezeUnavailableInFuturePeriod(pay)"
                      [attr.test-id]="'display-unfreezeUnavailable-popover-' + pay.id">
                  <p>
                    {{'PAYROLL_ONGOING.payslip_payment_generated_in_future' | translate}}
                  </p>
                </span>
              </ng-template>
            </td>
            <td gp-roles
                [userRoles]="['PAYROLL_WRITE']"
                class="nowrap">
              <ng-container *ngIf="!pay.readOnly">
                <div class="btn-bar-wrapper">
                  <div class="btn-bar btn-bar-xs flex-nowrap">
                    <!-- launch -->
                    <button class="btn btn-xs btn-outline-primary action-btn"
                            [disabled]="executingActions||pay.selected"
                            [ngClass]="isSelectedFor(pay, actions.LAUNCH)||pay.selected ? 'active' : 'inactive'"
                            [attr.aria-pressed]="isSelectedFor(pay, actions.LAUNCH) ? 'true' : 'false'"
                            (click)="executeSingleAction(pay, actions.LAUNCH)"
                            *ngIf="canDo(pay, actions.LAUNCH)">
                  <span class="hidden-xl-up action-tooltip"
                        [tooltip]="'PAYROLL_ONGOING.launch' | translate">
                  </span>
                      <span class="hidden-lg-down">{{ 'PAYROLL_ONGOING.launch' | translate }}</span>
                      <em *ngIf="isExecutionInProgress(pay, actions.LAUNCH, isLaunchAll)"
                          class="fa fa-light fa-spinner fa-spin"></em>
                      <span class="hidden-xl-up"><i class="fa fa-light fa-cog" aria-hidden="true"></i></span>
                    </button>
                    <!-- done -->
                    <button class="btn btn-xs btn-outline b-warning text-warning action-btn"
                            [disabled]="executingActions||pay.selected"
                            [ngClass]="isSelectedFor(pay, actions.DONE)||pay.selected ? 'active' : 'inactive'"
                            [attr.aria-pressed]="isSelectedFor(pay, actions.DONE) ? 'true' : 'false'"
                            (click)="executeSingleAction(pay, actions.DONE)"
                            *ngIf="canDo(pay, actions.DONE)">
                  <span class="hidden-xl-up action-tooltip"
                        [tooltip]="'PAYROLL_ONGOING.done' | translate">
                  </span>
                      <span class="hidden-lg-down">{{ 'COMMON.done' | translate }}</span>
                      <em *ngIf="isExecutionInProgress(pay,actions.DONE, isDoneAll)" class="fa fa-light fa-spinner fa-spin"></em>
                      <span class="hidden-xl-up"><i class="fa fa-light fa-key" aria-hidden="true"></i></span>
                    </button>
                    <!-- freeze -->
                    <button class="btn btn-xs btn-outline-success action-btn"
                            [disabled]="executingActions|| pay.selected"
                            [ngClass]="isSelectedFor(pay, actions.FIX)||pay.selected  ? 'active' : 'inactive'"
                            [attr.aria-pressed]="isSelectedFor(pay, actions.FIX)? 'true' : 'false'"
                            (click)="executeSingleAction(pay, actions.FIX)"
                            *ngIf="canDo(pay, actions.FIX)">
                  <span class="hidden-xl-up action-tooltip"
                        [tooltip]="'PAYROLL_ONGOING.freeze' | translate">
                  </span>
                      <span class="hidden-lg-down">{{ 'PAYROLL_ONGOING.freeze' | translate }}</span>
                      <em *ngIf="isExecutionInProgress(pay,actions.FIX, isFreezeAll)"
                          class="fa fa-light fa-spinner fa-spin"></em>
                      <span class="hidden-xl-up"><i class="fa fa-light fa-key" aria-hidden="true"></i></span>
                    </button>
                    <!-- unfreeze -->
                    <button class="btn btn-xs btn-outline-primary action-btn"
                            [disabled]="executingActions|| pay.selected"
                            [ngClass]="isSelectedFor(pay, actions.UNFREEZE)||pay.selected  ? 'active' : 'inactive'"
                            [attr.aria-pressed]="isSelectedFor(pay, actions.UNFREEZE)? 'true' : 'false'"
                            (click)="executeSingleAction(pay, actions.UNFREEZE)"
                            *ngIf="canDo(pay, actions.UNFREEZE)">
                  <span class="hidden-xl-up action-tooltip"
                        [tooltip]="'PAYROLL_ONGOING.unfreeze' | translate">
                  </span>
                      <span class="hidden-lg-down">{{ 'PAYROLL_ONGOING.unfreeze' | translate }}</span>
                      <em *ngIf="isExecutionInProgress(pay,actions.UNFREEZE, isUnfreezeAll)"
                          class="fa fa-light fa-spinner fa-spin"></em>
                      <span class="hidden-xl-up"><i class="fa fa-light fa-burn" aria-hidden="true"></i></span>
                    </button>
                  </div>
                </div>
              </ng-container>
            </td>
            <td class="text-center">
              {{pay.retroActivityCalculationCount && pay.retroActivityCalculationCount > 0 ? pay.retroActivityCalculationCount : ''}}
            </td>
            <td>
              <span class="label rounded danger pointer item-circle pay-indicator"
                    [class.zero]="!pay.nbCriticalAlert"
                    (click)="openPayEvents(pay, 'ALERT','ERROR_TECHNIC')">
                {{ pay.nbCriticalAlert | gpAlertNumber }}
              </span>

              <span class="label rounded warn pointer item-circle pay-indicator"
                    [class.zero]="pay.nbTotalAlert == pay.nbCriticalAlert"
                    (click)="openPayEvents(pay, 'WARNING','INFORMATION')">
                {{ pay.nbTotalAlert - pay.nbCriticalAlert | gpAlertNumber }}
              </span>
              <span class="label rounded item-circle pay-indicator" [ngClass]="{'zero' : !pay.nbLaunch}">
                {{ pay.nbLaunch | gpAlertNumber }}
              </span>
            </td>
            <td gp-roles
                [userRoles]="['PAYROLL_WRITE']"
                class="nowrap">
              <ng-container *ngIf="!pay.readOnly">
                <div class="btn-bar-wrapper">
                  <div class="btn-bar btn-bar-xs flex-nowrap">
                    <!-- Last done -->
                    <!-- Hotfix 21.01
                      <button class="btn btn-xs btn-outline-success action-btn" autocomplete="off"
                              [ngClass]="isSelectedFor(pay, actions.LAST_DONE) ? 'active' : 'inactive'"
                              [attr.aria-pressed]="isSelectedFor(pay, actions.LAST_DONE) ? 'true' : 'false'"
                              (click)="toggleSelection(pay, actions.LAST_DONE)"
                              [disabled]="executingActions"
                              *ngIf="canDo(pay, actions.LAST_DONE)">
                        <span class="hidden-xl-up action-tooltip"
                              [tooltip]="'PAYROLL_ONGOING.last_done' | translate">
                        </span>
                        <span class="hidden-lg-down">{{ 'PAYROLL_ONGOING.last_done' | translate }}</span>
                        <i *ngIf="executingActions && isSelectedFor(pay, actions.LAST_DONE)"
                           class="fa fa-light fa-spinner fa-spin"></i>
                        <span class="hidden-xl-up"><i class="fa fa-light fa-clock"></i></span>
                      </button>
                    -->
                    <button class="btn btn-xs btn-outline-primary action-btn"
                            [ngClass]="isSelectedFor(pay, actions.READY) ? 'active' : 'inactive'"
                            [attr.aria-pressed]="isSelectedFor(pay, actions.READY) ? 'true' : 'false'"
                            (click)="executeSingleAction(pay, actions.READY)"
                            [disabled]="executingActions||pay.selected"
                            *ngIf="canDo(pay, actions.READY)">
                      <span class="hidden-xl-up action-tooltip"
                            [tooltip]="'PAYROLL_ONGOING.ready' | translate">
                      </span>
                      <span class="hidden-lg-down">{{ 'PAYROLL_ONGOING.ready' | translate }}</span>
                      <em *ngIf="isExecutionInProgress(pay,actions.READY, false)"
                          class="fa fa-light fa-spinner fa-spin"></em>
                      <span class="hidden-xl-up"><i class="fa fa-light fa-check" aria-hidden="true"></i></span>
                    </button>
                    <button class="btn btn-xs btn-outline b-warn text-warning action-btn"
                            [ngClass]="isSelectedFor(pay, actions.CREATE_NEXT_PPC) ? 'active' : 'inactive'"
                            [attr.aria-pressed]="isSelectedFor(pay, actions.CREATE_NEXT_PPC) ? 'true' : 'false'"
                            (click)="executeSingleAction(pay, actions.CREATE_NEXT_PPC)"
                            [disabled]="executingActions||pay.selected"
                            *ngIf="canDo(pay, actions.CREATE_NEXT_PPC)">
                      <span class="hidden-xl-up action-tooltip"
                            [tooltip]="'PAYROLL_ONGOING.next_ppc' | translate">
                      </span>
                      <span class="hidden-lg-down">{{ 'PAYROLL_ONGOING.next_ppc' | translate }}</span>
                      <em *ngIf="isExecutionInProgress(pay,actions.READY, false)"
                          class="fa fa-light fa-spinner fa-spin"></em>
                      <span class="hidden-xl-up"><i class="fa fa-light fa-chevron-right" aria-hidden="true"></i></span>
                    </button>
                  </div>
                </div>
              </ng-container>
            </td>
            <td>
              <!-- Last execution -->
              <span class="btn btn-xs"
                    *ngIf="pay.lastExecution"
                    (click)="openResult(pay)">
                  {{ pay.lastExecution.time | gpDate: {withHour: true} : (triggerDateFormat$| async) }}
              </span>
            </td>
            <td>
              <!-- actions -->
              <a class="btn btn-xs btn-icon white"
                 (click)="hasPayslip(pay) ? openPay(pay) : openOverview(pay)"
                 target="_blank"
                 rel="noopener"
                 [class.disabled]="!hasPayslip(pay)">
                <i class="far fa-file-pdf" aria-hidden="true"></i>
              </a>
            </td>
          </tr>
          </tbody>
        </table>
      </div>


      <footer class="dker p-a" [gp-sticky]="'bottom'" [refreshOn]="dataLoaded">
        <div class="row">
          <div class="col-sm-8 col-lg-9 text-center text-center-xs">
            <ul class="pagination pagination-sm gp-pagination m-a-0" [class.gp-pagination-hidden]="!pagination.hasMultiplePages()">
              <li class="page-item" [ngClass]="{disabled: !pagination.hasPrevious()}">
                <a class="page-link" (click)="pagination.hasPrevious() && pagination.first()"><i
                  class="fa fa-light fa-angle-double-left" aria-hidden="true"></i></a>
              </li>
              <li class="page-item" [ngClass]="{disabled: !pagination.hasPrevious()}">
                <a class="page-link" (click)="pagination.hasPrevious() && pagination.previous()"><i
                  class="fa fa-light fa-angle-left" aria-hidden="true"></i></a>
              </li>
              <li *ngFor="let page of pagination.pages()" class="page-item"
                  [ngClass]="{active: page === pagination.currentPage.number + 1, disabled: page < 1}">
                <a *ngIf="page > 0" class="page-link" (click)="pagination.goToPage(page - 1)">{{ page }}</a>
                <a *ngIf="page < 1" class="page-link default-cursor">…</a>
              </li>
              <li class="page-item" [ngClass]="{disabled: !pagination.hasNext()}">
                <a class="page-link" (click)="pagination.hasNext() && pagination.next()">
                  <em class="fa fa-light fa-angle-right"></em>
                </a>
              </li>
              <li class="page-item" [ngClass]="{disabled: !pagination.hasNext()}">
                <a class="page-link" (click)="pagination.hasNext() && pagination.last()"><i
                  class="fa fa-light fa-angle-double-right" aria-hidden="true"></i></a>
              </li>
            </ul>
          </div>

        </div>
      </footer>
    </div>

  </div>


  <gp-modal gp-modal="launchConfirm" [closable]="true" size="sm">
    <div class="gp-modal-title" style="max-width: 90%">
      <h4 class="text-ellipsis">{{'FORMS.confirm' | translate}}</h4>
    </div>
    <div class="gp-modal-body">
      <form novalidate>
        <div [attr.data-hidden]="!countLaunch && !isLaunchAll">
          <div class="row">
            <div class="col-md-12 form-group">
              <label *ngIf="isLaunchAll; else launch">
                {{'PAYROLL_ONGOING.launch_all_' | translate:{massActionCount: massActionCount} }} {{'COMMON.payrolls'
                | translate}}
              </label>
              <ng-template #launch>
                <label>
                  <b>{{'PAYROLL_ONGOING.launch' | translate}}:</b> {{countLaunch}} {{'COMMON.payrolls' | translate}}
                </label>
              </ng-template>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 form-group">
              <label class="checkbox">
                <input type="checkbox" [(ngModel)]="isDebuggingMode" name="isDebuggingMode">
                {{'PAYROLL_ONGOING.debugging_mode' | translate}}
              </label>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 form-group">
              <label class="checkbox">
                <input type="checkbox" [(ngModel)]="isForceRetroactivity" name="forceRetroactivity">
                {{'PAYROLL_ONGOING.force_retroactivity' | translate}}
              </label>
            </div>
          </div>
          <div class="row" *ngIf="isForceRetroactivity">
            <div class="col-md-6 form-group">
              <label>{{'PAYROLL_ONGOING.force_retroactivity_until' | translate}}:</label>
            </div>
            <div class="col-md-6 form-group">
              <datepicker-input [(ngModel)]="retroactivityDate" name="retroactivityDate">
              </datepicker-input>
            </div>
          </div>
          <div class="row" gp-roles [userRoles]="['TECHNICAL_ADMIN']">
            <div class="col-md-12 form-group">
              Force priority
              <select class="form-control" [(ngModel)]="forcedPriority" name="forcedPriority">
                <option [value]="'HIGH'">HIGH</option>
                <option [value]="'MEDIUM'">MEDIUM</option>
                <option [value]="'LOW'">LOW</option>
              </select>
            </div>
          </div>
        </div>
        <div [attr.data-hidden]="isLaunchAll">
          <div class="row" [attr.data-hidden]="!countDone">
            <div class="col-md-12 form-group">
              <label>
                <b>{{'PAYROLL_ONGOING.done' | translate}}:</b> {{countDone}} {{'COMMON.payrolls' | translate}}
              </label>
            </div>
          </div>
          <div class="row" [attr.data-hidden]="!countFreeze">
            <div class="col-md-12 form-group">
              <label>
                <b>{{'PAYROLL_ONGOING.freeze' | translate}}:</b> {{countFreeze}} {{'COMMON.payrolls' | translate}}
              </label>
            </div>
          </div>
          <div class="row" [attr.data-hidden]="!countUnfreeze">
            <div class="col-md-12 form-group">
              <label>
                <strong>{{'PAYROLL_ONGOING.unfreeze' | translate}}
                  :</strong> {{countUnfreeze}} {{'COMMON.payrolls' | translate}}
              </label>
            </div>
          </div>
          <div class="row" [attr.data-hidden]="!countReady">
            <div class="col-md-12 form-group">
              <label>
                <b>{{'PAYROLL_ONGOING.ready' | translate}}:</b> {{countReady}} {{'COMMON.payrolls' | translate}}
              </label>
            </div>
          </div>
          <div class="row" [attr.data-hidden]="!countNext">
            <div class="col-md-12 form-group">
              <label>
                <b>{{'PAYROLL_ONGOING.next_ppc' | translate}}:</b> {{countNext}} {{'COMMON.payrolls' | translate}}
              </label>
            </div>
          </div>
          <div class="row" [attr.data-hidden]="!countLastDone">
            <div class="col-md-12 form-group">
              <label>
                {{'PAYROLL_ONGOING.last_done_confirm' | translate}}
              </label>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="gp-modal-footer">
      <button class="btn btn-dark p-x-md"
              (click)="executeSelectedConfirm()"
              test-id="confirmButton"
              id="confirmButton">
        {{'FORMS.confirm' | translate}}
      </button>
      <button type="button"
              class="btn btn-secondary p-x-md"
              (click)="executeSelectedCancel()">
        {{ 'FORMS.cancel' | translate }}
      </button>
    </div>
  </gp-modal>

</div>
